import { makeResponses } from '../response_factory';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { MirrorFileResult } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function file(config) {
    const downloadResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parsers.parseArrayBufferResponse),
    });
    const uploadResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(MirrorFileResult)),
    });
    return Object.freeze({
        /**
         * Serve some specific file in the uploads folder.
         *
         * Warning: The file will be deleted after you download it!
         *
         * @param arg The arguments to the function.
         * @param arg.filename The filename of the file to get.
         * @param arg.mime The mime type header to set on the response.
         * @param arg.asAttachment If truthy the response will have a `Content-Disposition: attachment` header set.
         * @param arg.name The filename for the attachment, defaults to the second part of the url.
         * @returns The requested file.
         */
        download: async ({ filename, mime = undefined, asAttachment = undefined, name = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/files/${filename}`, downloadResponse.v, undefined, {
                mime,
                as_attachment: asAttachment,
                name,
            });
            return result;
        },
        /**
         * Temporarily store some data on the server.
         *
         * @param arg The arguments to the function.
         * @param arg.requestBody The body of the request.
         * @param arg.maxAge The maximum amount of time (in seconds) this file will stay valid and can be retrieved.
         * @param arg.filename The name of the uploaded file.
         * @param arg.ephemeral If set this file will be never saved to persistent storage. The maximum size of file that can be uploaded like this is 1mb.
         * @returns The data for the file you can download on our server.
         */
        upload: async ({ requestBody, maxAge = undefined, filename = undefined, ephemeral = undefined, }) => {
            const body = requestBody;
            const result = await requestParams(config, 'POST', `/api/v1/files/`, uploadResponse.v, body, {
                max_age: maxAge,
                filename,
                ephemeral,
            });
            return result;
        },
    });
}
